export const RecipesPage = () => ({
  recipes: [],
  selectedRecipeHandle: "",
  get selectedRecipe() {
    if (!this.selectedRecipeHandle) return null;

    return this.recipes.find((recipe) => recipe.handle === this.selectedRecipeHandle);
  },
  init() {
    const recipesScript = document.querySelector("#recipes-json-dump");
    const recipes = recipesScript ? JSON.parse(recipesScript.innerText) : [];

    this.recipes = recipes;

    const url = new URL(window.location);

    if (url.searchParams.has("recipe")) {
      const handle = url.searchParams.get("recipe");
      this.selectedRecipeHandle = handle;
    }

    this.$watch("selectedRecipeHandle", (handle) => {
      const url = new URL(window.location);

      if (!handle) url.searchParams.delete("recipe");
      else url.searchParams.set("recipe", handle);

      window.scrollTo({ top: 0 });

      history.pushState({}, "", url);
    });
  },
});
